:host {
  width: 100%;
  height: 100%;
}

.wrapper {
  width: 100%;
  height: 100%;
  padding-top: calc(var(--spacer) * 2);
  display: block;

  .content-wrapper {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    position: relative;

    .add-integration-wizard {
      flex-basis: 105px;
      min-height: 105px;
      padding-left: calc(var(--spacer) * 4);
      padding-right: calc(var(--spacer) * 4);
      border-bottom: 1px solid var(--chart-101-pressed-dividers);
    }

    .form-wrapper {
      min-width: 500px;
      width: 100%;
      height: 100%;
      overflow-y: scroll;
    }

    .integration-type-list-wrapper {
      padding: calc(var(--spacer) * 3) calc(var(--spacer) * 3) calc(var(--spacer) * 3);
      padding-left: 40px;
    }

    .bottom-buttons {
      width: 100%;
      flex-basis: 65px;
      min-height: 65px;
      margin-top: auto;
      display: flex;
      align-items: center;

      border-top: 1px solid var(--chart-101-pressed-dividers);

      padding-left: calc(var(--spacer) * 5);
      padding-right: calc(var(--spacer) * 4);

      gz-button {
        margin-right: calc(var(--spacer) * 2);
      }
      #cancel-button {
        position: absolute;
        right: 28px;
      }
    }

    gz-integrations-requirements {
      padding-left: 0;
    }
  }

  .loading-container {
    display: none;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    gz-progress-spinner {
      display: flex;
      justify-content: center;
    }
  }

  &.is-loading {
    .content-wrapper {
      display: none;
    }

    .loading-container {
      display: flex;
    }
  }

  gz-integrations-edit-integration {
    width: 100%;
  }
}
